import { BasicLayout } from './Layouts/basicLayout'
import './ChangePassword.css'
import Profile from '../media/profile_picture2.svg'
import { useEffect, useState } from 'react'
import validate from '../utils/validatePasswordChange'
import validateInfo from '../utils/validateNewUser'
import axios from 'axios'
import {useNavigate} from 'react-router-dom'
import { useGlobalContent } from '../context/helpersProvider'
import apiRoutes from '../api/routes'
import { inputInterface } from '../utils/validateNewUser'
import { roleUser } from '../interfaces/roleUser'
import { MultiSelect } from "primereact/multiselect";
import expiredToken from '../utils/headerAuth'

export const ChangePassword = () => {
  const history = useNavigate()

  const [Input, setInput] = useState({
    pass: '',
    pass2: '',
    match: true,
  })

  interface Data {
    pass?: string
  }
  const [errors, setErrors] = useState<Data>({
    pass: ''
  })

  const [listLocation, setListLocation] = useState([
    "Argentina",
    "Brazil",
    "Chile",
    "Denmark",
    "France",
    "Germany",
    "Italy",
    "Panama",
    "Peru",
    "Switzerland",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Other"
  ]);


  type Role = {
    id: number;
    name: string;
  };

  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);
  const [selecteRole, setSelectedRole] = useState<Role[]>([]);

  function handleMultiSelectChange(value: string[]) {
    if (value.length > 0) {
      const lastSelected = value[value.length - 1]; // Toma la última selección
      setSelectedLocations([lastSelected]); // Actualiza el estado visual del MultiSelect
      setInputInfo((prev: any) => ({
        ...prev,
        location: lastSelected, // Almacena el último seleccionado como string
      }));
    } else {
      // Si no hay selecciones (se elimina todo), limpia el estado
      setSelectedLocations([]);
      setInputInfo((prev: any) => ({
        ...prev,
        location: '', // Limpia el campo de ubicación
      }));
    }
  }

  function handleRoleCompanyChange(value: Role[]) {
    if (value.length > 0) {
      const lastSelected = value[value.length - 1]; // Toma la última selección

      setSelectedRole([lastSelected]); // Actualiza el estado visual del MultiSelect
      setInputInfo((prev: any) => ({
        ...prev,
        roleCompany: lastSelected.id, // Almacena el último seleccionado como string
      }));
    } else {
      // Si no hay selecciones (se elimina todo), limpia el estado
      setSelectedRole([]);
      setInputInfo((prev: any) => ({
        ...prev,
        roleCompany: '', // Limpia el campo de ubicación
      }));
    }
  }

  const menu = process.env.REACT_APP_ENABLE_EMAIL_SC;

  const [errorsInfo, setErrorsInfo] = useState<inputInterface>({
    name: '',
    lastName: '',
    email: '',
    company: '',
    roleCompany: '',
    location: ''
  })

  useEffect(() => {
    if (localStorage.getItem('idClient') === null) {
      history('/')
    }
  })

  const { setShowLoading, setShowToast } = useGlobalContent()

  const [error] = useState('')
  const [prev, setPrev] = useState('')

  const [editinfo, setEditinfo] = useState(true)

  const handleChange = (e: any) => {
    const { name, value } = e.target
    if (name === 'pass') {
      setErrors(
        validate({
          [name]: value as string,
        })
      )
    }
    setInput({ ...Input, [name]: value })
  }

  const handlePrev = (e: any) => {
    setPrev(e.target.value)
  }

  const send = (e: any) => {
    e.preventDefault()
    if (!Input.pass || !Input.pass2 || Input.pass !== Input.pass2) {
      setInput({ ...Input, match: false })
      return
    } else if (!errors.pass) {
      let sessionId = localStorage.getItem('emailClient')
      setInput({ ...Input, match: true })
      setShowLoading('true')
      axios
        .put(apiRoutes.apiRecoverPassWithoutCode, {
          email: sessionId !== null && sessionId,
          prev_password: prev,
          password: Input.pass,
        })
        .then((json) => json.data)
        .then((datos) => {
          setShowLoading('false')
          if (datos.data) {
            setShowToast({ open: 'true', type: 'success', message: datos.message })
            setInput({
              match: true,
              pass: '',
              pass2: '',
            })
            setPrev('')
          } else {
            setShowLoading('false')
            setShowToast({ open: 'true', type: 'error', message: datos.message })
          }
        })
        .catch((err) => {
          expiredToken(history, err, setShowToast);
          setShowLoading('false')
        })
    }
  }

  const editinfoUser = (e: any) => {
    e.preventDefault()
    const err = validateInfo(inputInfo)
    if (Object.keys(err).length > 0) {
      // hay error
      setErrorsInfo({
        name: err?.name,
        lastName: err?.lastName,
        email: err?.email,
        company: err?.company,
        roleCompany: err?.roleCompany,
        location: err?.location,
      })
    } else {
      // no hay error
      setErrorsInfo({
        name: '',
        lastName: '',
        email: '',
        company: '',
        roleCompany: '',
        location: '',
      })
    }
    // setErrorsInfo(err)
    if (err.company || err.email || err.lastName || err.name || err.location) {
      return
    } else {
      setShowLoading('true')
      axios
        .put(apiRoutes.apiUpdateOwnProfile, {
          first_name: inputInfo.name?.trim(),
          last_name: inputInfo.lastName?.trim(),
          email: inputInfo.email?.trim(),
          company: inputInfo.company?.trim(),
          role: Number(inputInfo.roleCompany),
          location: inputInfo.location,
        })
        .then((json) => json.data)
        .then((datos) => {
          if (datos.data) {
            localStorage.setItem('emailClient', inputInfo.email)
            localStorage.setItem('nameClient', `${inputInfo.name} ${inputInfo.lastName}`)
            setShowToast({ open: 'true', type: 'success', message: datos.message })
          } else {
            setShowToast({ open: 'true', type: 'error', message: datos.message })
          }
        }).catch((err) => {
          expiredToken(history, err, setShowToast);
          setShowToast({ open: 'true', type: 'error', message: 'Unable to update profile' })
      });
      setShowLoading('false')
    }
  }

  const getUserInfo = async () => {
    return axios
      .get(apiRoutes.apiGetUser)
      .then((json) => json.data)
      .then((datos) => {
        // set inputInfo
        setInputInfo({
          name: datos.first_name,
          lastName: datos.last_name,
          email: datos.email,
          company: datos.company,
          roleCompany: datos.role_company,
          location: datos.location,
        })
        setSelectedLocations([datos.location]);
        return datos
      })
      .catch((err) => {
        expiredToken(history, err, setShowToast);
    });
  }
  const changeMode = (e: any) => {
    e.preventDefault()
    setEditinfo(!editinfo)
    setInput({
      ...Input,
      match: true,
    })
  }

  const [inputInfo, setInputInfo] = useState<inputInterface>({
    name: '',
    lastName: '',
    email: '',
    company: '',
    roleCompany: '',
    location: '',
  })
  const getRoles = async (roleAccessType: number) => {
    if (!roles) {
      setShowLoading('true')
      await axios
        .get(`/user/roleCompany/${roleAccessType}`)
        .then((json) => json.data)
        .then((datos) => {
          SetRoles(datos.data)
        })
        .catch((err) => {
          expiredToken(history, err, setShowToast);
        })
        .finally(() => {
          setShowLoading('false')
        })
    }
  }
  interface rolesUserInterface extends Array<roleUser> { }
  const [roles, SetRoles] = useState<rolesUserInterface>()

  function handleInputChange(e: any) {
    setInputInfo({
      ...inputInfo,
      [e.target.name]: e.target.value,
    })
  }
  function handleErrors(e: any) {
    const err = validateInfo(inputInfo)
    if (Object.keys(err).length > 0) {
      // hay error
      setErrorsInfo({
        name: err?.name,
        lastName: err?.lastName,
        email: err?.email,
        company: err?.company,
        roleCompany: err?.roleCompany,
        location: err?.location,
      })
    } else {
      // no hay error
      setErrorsInfo({
        name: '',
        lastName: '',
        email: '',
        company: '',
        roleCompany: '',
        location: '',
      })
    }
  }

  const Home = (e: any) => {
    e.preventDefault()
    history('/home');
  }

  const initalData = async () => {
    const userInfo = await getUserInfo()
    const roleAccessType = userInfo?.role_access_user === 1 ? 1 : 2
    await getRoles(roleAccessType)
  }

  useEffect(() => {
    initalData()
  }, [])

  useEffect(() => {
    if (roles && roles.length > 0) {
      const selectedRole = roles.find((role) => role.id === Number(inputInfo.roleCompany));
      if (selectedRole) {
        setSelectedRole([selectedRole]);
      }
    }
  }, [roles, inputInfo])

  return (
    <BasicLayout>
      <div className='content-div'>
        <div className='configuration-div'>
          <div>
            <div className='user-info-div'>
              <img width='105' src={Profile} loading='lazy' alt='profile ' className='user-image' />
              <div style={{ width: '80%' }}>

                <h4 className='user-name'>{localStorage.getItem('emailClient')}</h4>

                {/* <div className='user-email'>{localStorage.getItem('emailClient')}</div> */}
              </div>
            </div>
          </div>
          <div className='separador'></div>
          <div className='w-form'>
            <form method='post' name='wf-form-' data-name=''>
              <div className='filters-div'>
                {editinfo ? (
                  <>
                    <h3 className='h2-titles'>Information User</h3>
                    <div>
                      <label htmlFor='Your-name' className='field-label'>
                        Name
                      </label>
                      <input
                        type='text'
                        className='text-field normal w-input'
                        maxLength={256}
                        name='name'
                        placeholder='Your name'
                        onChange={handleInputChange}
                        onBlur={handleErrors}
                        value={inputInfo.name}
                        autoComplete="off"
                      />
                      {errorsInfo.name && <p className='alert'>{errorsInfo.name}</p>}
                    </div>
                    <div>
                      <label htmlFor='Lastname' className='field-label'>
                        Last Name
                      </label>
                      <input
                        type='text'
                        className='text-field normal w-input'
                        maxLength={256}
                        name='lastName'
                        data-name='Lastname'
                        placeholder='Your last name'
                        id='Lastname'
                        onBlur={handleErrors}
                        onChange={handleInputChange}
                        value={inputInfo.lastName}
                        autoComplete="off"
                      />
                      {errorsInfo.lastName && <p className='alert'>{errorsInfo.lastName}</p>}
                    </div>

                    <label htmlFor='Email' className='field-label'>
                      Email
                    </label>
                    <input
                      type='email'
                      className='text-field email w-input'
                      maxLength={256}
                      name='email'
                      data-name='Email'
                      placeholder='Your email'
                      id='Email'
                      onBlur={handleErrors}
                      onChange={handleInputChange}
                      value={inputInfo.email}
                      autoComplete="off"
                    />
                    {errorsInfo.email && <p className='alert'>{errorsInfo.email}</p>}
                    <label htmlFor='Company' className='field-label'>
                      Company
                    </label>
                    <input
                      type='text'
                      className='text-field company w-input'
                      maxLength={256}
                      name='company'
                      data-name='Email 2'
                      placeholder='Your Company'
                      id='Company'
                      onBlur={handleErrors}
                      onChange={handleInputChange}
                      value={inputInfo.company}
                      autoComplete="off"
                    />
                    {errorsInfo.company && <p className='alert'>{errorsInfo.company}</p>}
                    <label htmlFor='Location' className='field-label'>
                      Location
                    </label>
                    <MultiSelect
                      value={selectedLocations}
                      options={listLocation.map((item) => ({ label: item, value: item }))}
                      onChange={(e: any) => handleMultiSelectChange(e.value)}
                      placeholder="Select your location"
                      className="select-field location w-select-prime"
                      style={{
                        background: '#e7e9fa',
                        border: 'none',
                        color: '#333',
                        fontWeight: 600,
                        fontSize: '15px'
                      }}
                      appendTo={document.body}
                      panelHeaderTemplate={() => <></>}
                    />
                    {/* <select
                      className='select-field location w-select'
                      name='location'
                      id="Location"
                      onChange={handleInputChange}
                      value={inputInfo.location}
                      data-name=''
                    >
                      <option hidden value=''>Select your location</option>
                      {
                        listLocation.map((item) => (
                          <option key={item} value={item}>{item}</option>
                        ))
                      }
                    </select> */}

                    {errorsInfo.location && <p className='alert'>{errorsInfo.location}</p>}
                    <label htmlFor='Company-Position' className='field-label'>
                      Role
                    </label>
                    <MultiSelect
                      options={roles}
                      optionLabel="name"
                      style={{
                        background: '#e7e9fa',
                        border: 'none',
                        color: '#333',
                        fontWeight: 600,
                        fontSize: '15px'
                      }}
                      onChange={(e: any) => handleRoleCompanyChange(e.value)}
                      placeholder="Select your company position"
                      className="select-field  w-select-prime"
                      value={selecteRole}
                      maxSelectedLabels={1}
                      appendTo={document.body}
                      panelHeaderTemplate={() => <></>}
                    />
                    {/* <select
                      onChange={handleInputChange}
                      name='roleCompany'
                      data-name=''
                      className='select-field w-select'
                    >
                      <option hidden>
                        {
                          // buscar el rol que tiene el usuario y mostrar el nombre
                          roles?.map((e) => {
                            if (e.id === Number(inputInfo.roleCompany)) {
                              return e.name
                            }
                          })
                        }
                      </option>
                      {roles?.map((e) => (
                        <option value={e.id} key={e.id}>
                          {e.name}
                        </option>
                      ))}
                    </select> */}
                    {errorsInfo.roleCompany && <p className='alert'>{errorsInfo.roleCompany}</p>}
                    <br></br>
                  </>
                ) : (
                  <>
                    <h4 className='h3-title'>Change password</h4>
                    <label htmlFor='field' className='field-label'>
                      Current password
                    </label>
                    <input
                      type='password'
                      className='text-field pass w-input'
                      autoFocus={true}
                      maxLength={256}
                      name='current'
                      value={prev}
                      onChange={handlePrev}
                      placeholder='********'
                      autoComplete="off"
                    />
                    <label htmlFor='field' className='field-label'>
                      New password
                    </label>
                    <input
                      type='password'
                      className='text-field key w-input'
                      maxLength={256}
                      name='pass'
                      value={Input.pass}
                      onChange={handleChange}
                      placeholder='********'
                      autoComplete="off"
                    />
                    {errors.pass && <p className='alert'>{errors.pass}</p>}
                    <label htmlFor='field' className='field-label'>
                      Confirm password
                    </label>
                    <input
                      type='password'
                      className='text-field key w-input'
                      maxLength={256}
                      name='pass2'
                      value={Input.pass2}
                      onChange={handleChange}
                      placeholder='********'
                      autoComplete="off"
                    />
                  </>
                )}
                {!Input.match ? <span className='alert'>Both fields must match</span> : null}
                <div className='btns-div'>
                  <button
                    onClick={editinfo ? editinfoUser : send}
                    className='short-btn save w-button'
                  >
                    Confirm
                  </button>
                  {editinfo ? (
                    <button onClick={changeMode} className='short-btn-sin-icono'>
                      Change Password

                    </button>
                  ) : (
                    <button onClick={changeMode} className='short-btn-sin-icono'>
                      Edit information
                    </button>
                  )}

                  {menu === "false" && (
                    <button
                      onClick={Home}
                      className='short-btn-sin-icono'
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </BasicLayout>
  )
}
